<template>
    <div class="iframe-wrapper">
        <div class="lobby" @click="navToback">
            <van-icon name="wap-home" color="#fff" size="22" />
            {{ $t('game.lobby') }}
        </div>
        <iframe :src="iframeUrl" frameborder="0"></iframe>
    </div>
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
</template>
<script setup lang="ts">
import { getGameUrl } from '@/api/game'
import StatusPopup from '@/components/common/statusPopup.vue'
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const router = useRouter()
const route = useRoute();
const GameType = ref(route.query.game_type);
const gameMakerID = ref(route.query.game_maker);
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const iframeUrl = ref("")

const navToback = () => {
    router.go(-1)
}
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const gameUrl = () => {
    let params = {
        gameId: GameType.value,
        gameMakerId : gameMakerID.value
    }
    getGameUrl(params).then(res => {
        let resData = res.data
        iframeUrl.value = resData.game_url
        // let resData = res.data.data
        // iframeUrl.value = resData.game_url
    }).catch(err => {
        showError(err);
    })
}

onMounted(() => {
    gameUrl()
})
</script>
<style scoped>
.iframe-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    margin: 0;
    padding: 0;
    z-index: 9999;
    background: #000;
}

.iframe-wrapper iframe {
    width: 100%;
    height: 100%;
    border: none;
}

.lobby {
    position: absolute;
    color: #fff;
    background: #0009;
    border-radius: 30px;
    width: 30px;
    height: 30px;
    padding: 10px;
    border: 1px solid #fff;
    font-size: 10px;
    margin: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
</style>